import { useEffect, useRef } from "react";

const TradingViewChart = ({ symbol }) => {
  const chartRef = useRef(null);

  useEffect(() => {

    // old chart remove
    if (chartRef.current) {
      chartRef.current.innerHTML = "";
    }

    const loadWidget = () => {
      new window.TradingView.widget({
        width: "100%",
        height: 400,

        // 👇 dynamic symbol
        symbol: symbol || "NASDAQ:AAPL",

        interval: "15",
        timezone: "Asia/Kolkata",
        theme: "dark",
        style: "1",
        locale: "en",
        toolbar_bg: "#0b1220",
        enable_publishing: false,
        hide_top_toolbar: false,
        hide_legend: false,
        container_id: "tv_chart_container",
      });
    };

    // script already loaded
    if (window.TradingView) {
      loadWidget();
      return;
    }

    // first time script load
    const script = document.createElement("script");

    script.src = "https://s3.tradingview.com/tv.js";

    script.async = true;

    script.onload = () => {
      loadWidget();
    };

    document.body.appendChild(script);

  }, [symbol]);

  return (
    <div
      id="tv_chart_container"
      ref={chartRef}
    ></div>
  );
};

export default TradingViewChart;